import { render, staticRenderFns } from "./CapituloUnoPage.vue?vue&type=template&id=31498b83"
import script from "./CapituloUnoPage.js?vue&type=script&lang=js&external"
export * from "./CapituloUnoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports